import Hidden from '@material-ui/core/Hidden';
import withWidth, {
  WithWidthProps,
} from '@material-ui/core/withWidth/withWidth';
import React, { Dispatch, PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { SegmentTypes } from '../../../models/itinerary';
import { AppState } from '../../../store/model';
import { toggleConfirmDialog } from '../../../store/reducers/confirm-dialog/actions';
import { isNew, isSaviSelectIntl } from '../../../store/reducers/itinerary/selectors';
import { findSegment as findSegmentDetails } from '../../../store/reducers/segment-details/selectors';
import { findSegment as findSegmentOptions } from '../../../store/reducers/segment-options/selectors';
import { selectOption } from '../../../store/reducers/selected-options/actions';
import {
  findSelectedOption,
  getOptionIdFromOption,
} from '../../../store/reducers/selected-options/selectors';
import { cancelSegment as deselectSegment } from '../../../store/reducers/selected-segment/actions';
import { ContentDesktop } from './ContentDesktop';
import { ContentMobile } from './ContentMobile';
import { getSegmentTypeForSaviSelectIntl } from '../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  segmentId: number;
}

interface StateProps {
  selectedOptionId: string;
  optionIds: string[];
  title: string;
  type: SegmentTypes;
  show: boolean;
  isSaviIntl: boolean;
}

interface DispatchProps {
  onSegmentDeselect(): void;
  onOptionSelect(
    segmentId: number,
    optionId: string,
    isRecommended: boolean,
  ): void;
  openRequestChangesDialog(): void;
}

interface State {
  currentOptionIndex: number;
}

interface ContentProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithWidthProps {}

class ContentBase extends PureComponent<ContentProps, State> {
  public render() {
    const { width, isSaviIntl, ...props } = this.props;

    return (
      <>
        { !isSaviIntl ? (
          <>
            <Hidden smDown>
              <ContentDesktop {...props} />
            </Hidden>
            <Hidden mdUp>
              <ContentMobile {...props} />
            </Hidden>
          </>
        ) : (
          <ContentDesktop {...props} />
        )}
      </>
    );
  }
}

const mapStateToProps = (
  state: AppState,
  { segmentId }: ContentProps,
): StateProps => {
  if(!isSaviSelectIntl(state)) {
    const { optionIds } = findSegmentOptions(segmentId)(state);
    const selectedOption = findSelectedOption(segmentId)(state);
    const { title, type } = findSegmentDetails(segmentId)(state);

    return {
      optionIds,
      selectedOptionId: getOptionIdFromOption(selectedOption),
      title,
      type,
      show: isNew(state),
      isSaviIntl: false,
    };
  } else {
    return {
      optionIds: [],
      selectedOptionId: "",
      title: "",
      type: getSegmentTypeForSaviSelectIntl(segmentId)(state),
      show: false,
      isSaviIntl: true,
    };
  }
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  onSegmentDeselect: () => {
    dispatch(deselectSegment());
  },
  onOptionSelect: (
    segmentId: number,
    optionId: string,
    isRecommended: boolean,
  ) => {
    dispatch(selectOption(segmentId, optionId, isRecommended));
  },
  openRequestChangesDialog() {
    dispatch(toggleConfirmDialog(true, 'Rejected'));
  },
});

const enhance = compose<ContentProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withWidth(),
);

/**
 * Segment content
 *
 * Switches between ContentDesktop and ContentMobile depending on screensize
 *
 * @see ContentDesktop
 * @see ContentMobile
 */
export const Content = enhance(ContentBase);

Content.displayName = 'Content';
